export const COMPANY_GROUP_COMPANIES_SET_LOADING =
  'COMPANY_GROUP_COMPANIES/SET_LOADING';
export const COMPANY_GROUP_COMPANIES_SET_ERROR =
  'COMPANY_GROUP_COMPANIES/SET_ERROR';
export const COMPANY_GROUP_COMPANIES_SET_GROUPS =
  'COMPANY_GROUP_COMPANIES/SET_GROUPS';

export const COMPANY_GROUP_COMPANIES_FETCH_GROUPS =
  'COMPANY_GROUP_COMPANIES/FETCH_GROUPS';

export const COMPANY_GROUP_COMPANIES_GET_GROUPS =
  'COMPANY_GROUP_COMPANIES/GET_GROUPS';
export const COMPANY_GROUP_COMPANIES_GET_LOADING =
  'COMPANY_GROUP_COMPANIES/GET_LOADING';
export const COMPANY_GROUP_COMPANIES_GET_ERROR =
  'COMPANY_GROUP_COMPANIES/GET_ERROR';
